import React from "react";
// import TableComandas from "../components/TableComandas";
import AppMovimientoReactTable from "../table/AppMovimientoReactTable";

import Footer from "../components/Footer";

import "../css/footer.css";

const Movimientos = () => {
  return (
    <>
      <AppMovimientoReactTable />
      {/* <TableComandas /> */}
      <Footer />
    </>
  );
};

export default Movimientos;
